import './style.scss';
import { Grid } from '@mui/material';
import { Navigate, Route, Routes } from 'react-router-dom';
import Home from './Home';
import Destination from './Destination';


const Content = () => {
    return <Grid item xs={12} className='grid-content'>
        <Routes>
            <Route path='/' element={<Home />} />
            <Route path='/:key' element={<Destination />} />
            <Route path="*" element={<Navigate to="/" replace={true} />} />
        </Routes>
    </Grid>;
}

export default Content;